<template>
  <v-container
    fluid
    class="patch-care">
    <h2>
      Patch Care Guide
    </h2>
    <div class="patch-care__body">
      <img
        src="@/assets/images/careguide.png"
        class="patch-care__image">
      <v-btn
        href="/memerhats-patch-care-guide.pdf"
        target="_blank"
        flat
        color="primary">
        <v-icon>save</v-icon>
        Download as PDF
      </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'PatchCare',
  data() {
    return {
      //
    };
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.patch-care
  display: flex
  flex-flow: column nowrap
  align-items: flex-start
  &__body
    display: flex
    flex-flow: column nowrap
    align-items: center
  &__image
    width: 100%
    max-width: 28rem
    border: 1px solid $accent

</style>
